import {TRANSLATION_NL} from 'src/environments/ett/translations/nl';
import {TRANSLATION_EN} from 'src/environments/ett/translations/en';
import {TRANSLATION_DE} from 'src/environments/ett/translations/de';
import {TRANSLATION_TR} from 'src/environments/ett/translations/tr';
import {TRANSLATION_PL} from 'src/environments/ett/translations/pl';
import {TRANSLATION_RO} from 'src/environments/ett/translations/ro';
import {TRANSLATION_PT} from 'src/environments/ett/translations/pt';
import {TRANSLATION_BG} from 'src/environments/ett/translations/bg';

export const environment = {
    production: false,
    id: 'nl.ett.wave.test',
    name: 'Iedereen veilig thuis',
    version: '4.8.0',
    author: {
        name: 'ETT',
        email: 'info@ett-wave.nl',
        website: 'https://recognize.nl/',
    },
    deprecation: {
        domains: [],
        date: '2099-09-01T00:00:00',
    },
    host: 'vwwave',
    storage: '__wave',
    initialTheme: '',
    color: {
        primary: '#32659C',
        statusBar: {
            default: '#336699',
            overlay: '#14293D',
        },
    },
    supportedLanguages: [
        {
            value: 'nl',
            label: 'Nederlands',
            translationFile: TRANSLATION_NL,
        },
        {
            value: 'de',
            label: 'Deutsch',
            translationFile: TRANSLATION_DE,
        },
        {
            value: 'en',
            label: 'English',
            translationFile: TRANSLATION_EN,
        },
        {
            value: 'tr',
            label: 'Türkçe',
            translationFile: TRANSLATION_TR,
        },
        {
            value: 'pl',
            label: 'Polsku',
            translationFile: TRANSLATION_PL,
        },
        {
            value: 'ro',
            label: 'Romana',
            translationFile: TRANSLATION_RO,
        },
        {
            value: 'pt',
            label: 'Portugues',
            translationFile: TRANSLATION_PT,
        },
        {
            value: 'bg',
            label: 'български',
            translationFile: TRANSLATION_BG,
        },
    ],
    api: 'https://ett.wave.tst.recognize.dev',
    apiTimeout: 60000,
    msAuth: {
        tenantId: 'common',
        clientId: '79501900-ee6e-43ba-b1aa-0b7da3c6c0db',
        keystoreHash: 'Pz8oP2kJPz9ZPz8/Px1teB9qPxYNCg==',
        scopes: ['api://79501900-ee6e-43ba-b1aa-0b7da3c6c0db/default'],
        redirectUri: 'https://app.ett.wave.tst.recognize.dev',
    },
    deeplinks: [
        'https://ett.wave.tst.recognize.dev/deeplink/',
        'https://app.ett.wave.tst.recognize.dev/deeplink/',
    ],
    whitelistedDomains: [
        'ett.wave.tst.recognize.dev',
        'app.ett.wave.tst.recognize.dev',
    ],
    privacyPolicyUrl: 'https://ett-wave.nl/documents/privacy-policy.html',
    instructionFilmUrl: '',
    applicationInsights: {
        instrumentationKey: 'eb8bfad4-bbb6-4f75-a6b7-dccb822607d5',
    },
};
